<template lang="html">
  <div id="banner">
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-for="(i, key) in 3" :key="key" @mouseenter.native="stopPlay" @mouseleave.native="play">
        <img :src="'/images/banner'+i+'.png'" />
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination"  slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'carrousel',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active'
        },
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    //console.log('this is current swiper instance object', this.swiper)
    //this.swiper.slideTo(3, 1000, false)
  },
  methods: {
    stopPlay() {
      this.swiper.autoplay.stop();
    },
    play() {
      this.swiper.autoplay.start();
    }
  },
}
</script>

<style lang="less">
#banner {
  margin-top: 110px;
  min-width: 1200px;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;
  }
}

.my-bullet {
  display: inline-block;
  width: 38px;
  height: 8px;
  margin: 15px;
  border-radius: 4px;
  background: #fff;
  opacity: 0.6;
}

.my-bullet-active {
  cursor: pointer;
  background: #FF9E40;
}
</style>
